export default __webpack_public_path__ + "static/media/zori_l.ff4e6119.jpg";